import manifest from "./manifest.js";

const aliases = {
  [manifest.core.SABLIER_V2_LOCKUP_DYNAMIC]: "LD2",
  [manifest.core.SABLIER_V2_LOCKUP_LINEAR]: "LL2",
  [manifest.periphery.SABLIER_V2_MERKLE_STREAMER_FACTORY]: "MSF2", // MSF = Merkle Streamer Factory
};

export default aliases;
